import { CCard, CCardBody, CCardHeader, CCol, CRow } from "@coreui/react";
import React from "react";
const Permissions = () => {
  return (
    <CRow className="content">
      <CCol xs={12}>
        <CCard className="mb-4 custom-card">
          <CCardHeader className="custom-card-header">
            <h5>Permissions tab</h5>
          </CCardHeader>
          <CCardBody>permissions body</CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default Permissions;
